module.exports = __webpack_public_path__ + "img/shipo-menu-home-white.573d889a.svg";